import type { CompletedAudit } from "./types";

export async function downloadAuditReport(audit: CompletedAudit): Promise<void> {
  if (!window.CallAuditReport || !window.CallAuditXlsxStyle) {
    throw new Error("Модули оформления Excel не загрузились. Обновите страницу.");
  }
  const report = window.CallAuditReport.buildWorkbook({
    results: audit.results,
    warnings: audit.warnings,
    sourceName: audit.sourceName,
    XLSX: window.XLSX,
    CallAudit: window.CallAudit,
  });
  const raw = window.XLSX.write(report.workbook, {
    bookType: "xlsx",
    type: "array",
    compression: true,
    cellDates: true,
    cellStyles: true,
  });
  const payload = await window.CallAuditXlsxStyle.apply(raw, report.stylePlan);
  const url = URL.createObjectURL(new Blob([payload], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }));
  const link = document.createElement("a");
  link.href = url;
  link.download = window.CallAuditReport.outputName(audit.sourceName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
